import type { ComputePaths } from '../types';

/** 弹窗内独立 Form 的固定字段路径（与主表单 pathPrefix 无关） */
export const MODAL_PATHS: ComputePaths = {
  architecture: 'architecture',
  cpuCards: 'cpu.physicalCards',
  cpuCores: 'cpu.physicalCores',
  cpuLogical: 'cpu.logicalCores',
  cpuRequest: 'cpu.request',
  cpuPricing: 'cpuPricing',
  memory: 'memory',
  memoryPricing: 'memoryPricing',
  gpu: 'gpu',
  gpuPricing: 'gpuPricing',
  bandwidth: 'bandwidth',
  bandwidthPricing: 'bandwidthPricing',
  hpcRdma: 'hpcRdma',
};

export const MODAL_VALIDATE_FIELDS: Record<'cpu' | 'memory' | 'gpu', string[]> = {
  cpu: [MODAL_PATHS.cpuCards, MODAL_PATHS.cpuCores, MODAL_PATHS.cpuLogical],
  memory: [MODAL_PATHS.memory],
  gpu: [`${MODAL_PATHS.gpu}.vendor`, `${MODAL_PATHS.gpu}.device`, `${MODAL_PATHS.gpu}.number`],
};

export function resolveModalCpuValidateFields(cpuSimpleMode?: boolean): string[] {
  return cpuSimpleMode && MODAL_PATHS.cpuRequest ? [MODAL_PATHS.cpuRequest] : MODAL_VALIDATE_FIELDS.cpu;
}
